import { ref } from 'vue';
import type { ApiService } from '../backend/ApiService';
import { DeepPartial } from '../../../../zabbix-shared/interfaces/intefaces';

export class ListManager<T> {
  items = ref<T[] | null>();
  loading = ref(false);
  error = ref<unknown>(null);
  service: ApiService<T>;
  companyId: number | undefined;

  constructor(service: ApiService<T>, companyId?: number) {
    this.service = service;
    this.companyId =  companyId;
  }

  async fetchAll(params?: any) {
    this.loading.value = true;
    try {
      this.items.value = await this.service.findAll(params);
    } catch (err) {
      this.error.value = err;
    } finally {
      this.loading.value = false;
    }
  }

  async add(data: DeepPartial<T>) {
    if(this.companyId){
      Object.assign(data as object, {company: {id: this.companyId}})
    }

    const newItem = await this.service.create(data);
    this.items?.value?.push(newItem);
    return newItem;
  }

  async remove(id: number) {
    await this.service.delete(id);
    this.items.value = this.items?.value?.filter((item: any) => item.id !== id);
  }

  async update(id: number, data: DeepPartial<T>) {
    if(this.companyId){
      Object.assign(data as object, {company: {id: this.companyId}})
    }

    const updatedItem = await this.service.update(id, data);
    if (this.items.value) {
      const index = this.items.value.findIndex((item: any) => item.id === id);
      if (index !== -1) {
        this.items.value[index] = updatedItem;
      }
    }
    return updatedItem;
  }
}
